import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/vercel/path0/layouts/error.vue").then(m => m.default || m))
}